module.exports = function getResource(label, vars = []) {
    const resources = { title: 'Récemment consulté' };

    return resources[label];
};
